<template>
    <div onclick="">
        <Header currentpage="partner"/>
        <div id="partnerbg" class="reduced-margin" >
            <!-- image is added and styled in web-style.css -->
            <div class="row">
                <div class="col s12 m12 l12 center">
                    <div id="join-text" > Join our Zapy Partner Program </div>

                    <div class = "elaboration">
                        <span>for access to a number of program benefits, such as</span><br/>
                        <span>trainings, rebate, and a first-look at our latest features.</span>
                    </div>
                    <div class="double-down-arrow">
                    <div >
                        <img src="/assets/img/down_arrow.svg">
                    </div>
                    <div>
                        <img src="/assets/img/down_arrow.svg">
                    </div>
                    </div>

                     
                    <div class="center">
                        <div class="text-border">
                            <div id="contact-size">
                                <span id="contact-us"> Want to learn more?</span><br/>
                                <span id="contact-us"> Contact us at </span><br/>
                                <span id="contact-info"> <a class="hide-on-med-and-up" style="color:white;" href="tel:+6620263748">+(66) 2-026-3748</a><span class="hide-on-med-and-down">+(66) 2-026-3748</span>  |  <a href="mailto:sales@zapy.io" style="color:white;">sales@zapy.io</a> </span>
                            </div>
                        </div>
                    </div>
                     
                </div>
            </div>
        </div>

        
            <div class="partnerbg2 phonebg">
                <!-- background added and styled in custom.css -->

                <div class="row">
                    <div class="col s12 m12 l12 pre-form">
                        <div>
                            <div id="interested-container">
                                <span id="interested">Interested in Digitizing Your Event?</span>
                            </div>
                            <div id="elaboration-container">
                                <span class="elaboration" id="interested-elaboration"> Fill in the following form and our Zapy <br/>representatives will get back to you!</span>
                            </div>

                            <div class="hubspot-form-container">
                                <div id="hubspotForm">                 
                                </div>                                
                            </div>
                        
                    
                        </div>
                    </div>
                </div>
            <div class="row row-bottom-0">
                <div><div id="descriptive-words" class="col s12 m12 l12 center"> Reliable  |  Scalable  |  Cost Effective </div></div>
            </div>
        </div>
        <section id="contactus" class="section scrollspy">
        <Footer/>
        </section>
    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Partner",
  components: {
    Header,
    Footer
  },
  mounted() {
    const script = document.createElement("script");
    //js.hsforms.net/forms/shell.js
    script.src = "https://js.hsforms.net/forms/shell.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "2710734",
          formId: "810562ed-2c29-443a-a327-4348da856a84",
          target: "#hubspotForm"
        });
        
      }
    });
  },
  created: function(){
      document.title = "ZAPY - Become A ZAPY Partner"
      document.head.querySelector('meta[name=description]').content = 'Win more clients by taking your event to the next level.'

      //Activate Scroll Spy 
    setTimeout(function() {
      var scrolloptions = {
        activeClass: "scrollspy-active",
        throttle: 100,
        scrollOffset: 520       
      };
      var scrollelem = document.querySelectorAll(".scrollspy");
      //eslint-disable-next-line
      var scrollinstance = M.ScrollSpy.init(scrollelem, scrolloptions);
    }, 500);    

  }
};
</script>




